import {
  ClampToEdgeWrapping,
  DataTexture,
  DoubleSide,
  FloatType,
  LinearFilter,
  Mesh,
  PlaneBufferGeometry,
  RedFormat,
  ShaderMaterial,
  UVMapping,
} from "three";
import vertexShader from "raw-loader!glslify-loader!./shaders/FunctionSurfaceVert.glsl";
import fragmentShader from "raw-loader!glslify-loader!./shaders/FunctionSurfaceFrag.glsl";

function amin(a, map = (x) => x) {
  return a.reduce((a, b) => Math.min(a, map(b)), +Infinity);
}

function amax(a, map = (x) => x) {
  return a.reduce((a, b) => Math.max(a, map(b)), -Infinity);
}

const material = new ShaderMaterial({
  uniforms: {
    heightMap: { value: null },
    heightScale: { value: 1 },
    progress: { value: 1 },
    xBounds: { value: [-1, 1] },
    yBounds: { value: [-1, 1] },
    disc: { value: false },
  },
  side: DoubleSide,
  vertexShader,
  fragmentShader,
});

export default class FunctionSurface extends Mesh {
  constructor(data) {
    super(
      new PlaneBufferGeometry(1, 1, data.x.length, data.y.length),
      material.clone()
    );

    this.frustumCulled = false;

    this.xBounds = [amin(data.x), amax(data.x)];
    this.yBounds = [amin(data.y), amax(data.y)];

    const u = this.material.uniforms;
    u.heightMap.value = new DataTexture(
      new Float32Array(data.f),
      data.x.length,
      data.y.length,
      RedFormat,
      FloatType,
      UVMapping,
      ClampToEdgeWrapping,
      ClampToEdgeWrapping,
      LinearFilter,
      LinearFilter
    );
    u.heightScale.value = 1 / amax(data.f, Math.abs);
    u.xBounds.value = this.xBounds;
    u.yBounds.value = this.yBounds;
    u.progress.value = 1;
  }

  set progress(v) {
    this.material.uniforms.progress.value = v;
  }

  set disc(d) {
    this.material.uniforms.disc.value = d;
  }

  dispose() {
    this.material.dispose();
    this.geometry.dispose();
    this.material.uniforms.heightMap.value.dispose();
  }
}
